module.exports = __webpack_public_path__ + "static/logo-f580bf1865181dc09adf199e1de171cc.png";